import type { ImageBlock } from "@mw/shared/payload-types";

import { getImageProps } from "@utilities/payload";
import clsx from "clsx";
import NextImage from "next/image";

export type BackgroundForegroundImage = NonNullable<ImageBlock["asset"]["backgroundForegroundImage"]>;

interface DesktopMobileImageProps {
  imageConfig: BackgroundForegroundImage;
  className?: string;
  mobileClassName?: string;
}

export const DesktopMobileImage = ({ imageConfig, className, mobileClassName }: DesktopMobileImageProps) => {
  const desktopProps = getImageProps(imageConfig?.foreground, {
    placeholder: true,
    fill: true,
  });
  const mobileProps = getImageProps(imageConfig?.mobileForeground, {
    placeholder: true,
    fill: true,
  });

  if (!desktopProps) return null;

  const hasMobile = !!mobileProps;

  return (
    <>
      <NextImage {...desktopProps} className={clsx(className, hasMobile && "tw-hidden md:tw-block")} />
      {mobileProps && <NextImage {...mobileProps} className={clsx(className, mobileClassName, "md:tw-hidden")} />}
    </>
  );
};
